export default "__VITE_ASSET__4438ef4b__"